
















































































































import { NavigationDataStore } from '@store/modules/navigation';
import {
    useVueRouter,
    useVuexStore,
} from '@superbet-group/web.lib.vue-utilities';
import {
    computed,
    defineComponent,
    ref,
    watch,
} from '@vue/composition-api';
import { RouteName } from '@app/router/constants/RouteName';
import HeaderNavigation from './headerNavigation/HeaderNavigation.vue';
import HubNavigation from './headerNavigation/HubNavigation.vue';
import SdsGlobalHeaderLogo from './SdsGlobalHeaderLogo.vue';
import SdsGlobalHeaderIcon from './SdsGlobalHeaderIcon.vue';
import {
    GamingRoutes,
    NavigationContext,
    Site,
} from '@superbet-group/web.types';
import AccountContainer from '@app/shared/components/Account/AccountContainer.vue';
import { SdsButton } from '@superbet-group/web.lib.ui-components';
import modalStore from '@store/modules/ui/shared/modal/modalIndex';
import modalCodes from '@store/modules/ui/shared/modal/modalCodes';
import { AuthenticationStore } from '@store/modules/data/authentication/authenticationIndex';
import NewAccountMenu from '@src/app/shared/components/Account/NewAccountMenu.vue';
import FtdReminderPopover from '@src/federations/wallet/src/modules/ftdReminder/FtdReminderPopover.vue';
import QuickDepositButton from '@walletFederation/src/modules/quickDeposit/QuickDepositButton.vue';
import LanguageSwitcher from '@src/app/localization/components/LanguageSwitcher.vue';
import { getCurrentSite } from '@app/utils/domainHelpers';
import { AccountFlagNames } from '@modules/userProfile/account/FeatureFlags';
import { featureFlagService } from '@superbet-group/web.lib.flags';
import { Analytics as AnalyticsSDK } from '@superbet-group/web.analytics.sdk';
import { AdditionalDepositButtonType } from '@core/models/user/flags';
import HeaderNavigationSkeleton from './headerNavigation/skeletons/HeaderNavigationSkeleton.vue';
import { getCurrentBrand } from '@src/app/shared/brand/brand';
import { getShellConfig } from '@src/config/shell/config';

export default defineComponent({
    emits: ['pageClick'],
    props: {
        isBeingLoaded: {
            type: Boolean,
            default: false,
        },
    },
    setup(props) {
        const { router, route } = useVueRouter();

        const authModule = useVuexStore<AuthenticationStore>('data/authentication');
        const user = authModule.getter('user');
        const isCheckedAuthentication = authModule.getter('isCheckedAuthentication');

        const navigationModule = useVuexStore<NavigationDataStore>('navigation');
        const currentNavigationContext = navigationModule.getter('currentNavigationContext');

        const whichAdditionalDepositButtonEnabled = ref<AdditionalDepositButtonType>(AdditionalDepositButtonType.None);

        watch(props, async (nextProps) => {
            if (nextProps.isBeingLoaded) {
                return;
            }

            whichAdditionalDepositButtonEnabled.value = await featureFlagService.getFeatureValue(
                AccountFlagNames.whichAdditionalDepositButtonShown,
                AdditionalDepositButtonType.None,
            );
        }, {
            immediate: true,
        });

        const isFirstTimeDeposit = computed(() => user.value !== null && !user.value?.hasMadeDeposit);
        const isHeaderDepositButtonEnabled = computed(() => whichAdditionalDepositButtonEnabled.value === AdditionalDepositButtonType.HeaderBar);
        const isDepositButtonShown = computed(() => (
            isFirstTimeDeposit.value
            && isHeaderDepositButtonEnabled.value
        ));

        const modalModule = useVuexStore<typeof modalStore>('ui/modal');
        const setModal = modalModule.action('setModal');
        function openLoginModal() {
            setModal({ code: modalCodes.login });
        }

        function goToRegisterRoute() {
            router.value.push({
                name: RouteName.Account.Register,
            });
        }

        function goToDepositRoute() {
            AnalyticsSDK.getInstance().log(
                'Deposit_Option_Chosen',
                {
                    whichOption: 'Header_button',
                },
            );
            router.value.push({
                name: RouteName.Account.Deposit,
            });
        }

        const isHubPage = computed(() => getShellConfig().remoteConfig.areSitesSplitByLicence && route.value.name === RouteName.GrowthMarketing.LandingIntro);

        watch(currentNavigationContext, (newValue) => {
            if (newValue) {
                const brand = getCurrentBrand(newValue);
                document.querySelector('html')?.setAttribute('data-brand', brand);
            }
        }, { immediate: true });

        const isAccountDropdownVisible = ref(false);

        const redirectOrShowAccountMenu = () => {
            if (
                getShellConfig().localConfig.header.accountMenuAuthenticated?.isRedirect
                && getShellConfig().localConfig.header.accountMenuAuthenticated?.redirectRouteName
                && user.value
            ) {
                router.value.push({
                    name: getShellConfig().localConfig.header.accountMenuAuthenticated?.redirectRouteName,
                });
            } else {
                isAccountDropdownVisible.value = true;
            }
        };

        return {
            searchRouteName: computed(() => currentNavigationContext.value === NavigationContext.Sports ? RouteName.Sport.Search : GamingRoutes.MyCasinoSearch),
            notificationsRouteName: RouteName.BonusAndComms.Notifications,
            user,
            isAccountDropdownVisible,
            isDepositButtonShown,
            isNapoleonGames: getCurrentSite(window.location.hostname) === Site.NapoleonGames,
            hasNotificationsIcon: getShellConfig().localConfig.header.hasNotificationsIcon,
            isHubPage,
            isAccountDropdownEnabled: !getShellConfig().localConfig.header.accountMenuAuthenticated?.isRedirect || !user.value,
            openLoginModal,
            goToRegisterRoute,
            goToDepositRoute,
            isCheckedAuthentication,
            redirectOrShowAccountMenu,
            hideDropdown: () => isAccountDropdownVisible.value = false,
        };
    },
    components: {
        HeaderNavigation,
        HubNavigation,
        SdsGlobalHeaderLogo,
        SdsGlobalHeaderIcon,
        AccountContainer,
        SdsButton,
        NewAccountMenu,
        QuickDepositButton,
        LanguageSwitcher,
        FtdReminderPopover,
        HeaderNavigationSkeleton,
    },
});
